import Loadable from '../../../components/loadable';

const ContactInnertelligence = Loadable({
  loader: () => import('react/pages/contacts/access_control/contact_innertelligence'),
  type: 'block',
});

angular.module('gym').value('ContactInnertelligence', ContactInnertelligence);
